import script from "./EudonetLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./EudonetLogo.vue?vue&type=script&setup=true&lang=ts"

import "./EudonetLogo.vue?vue&type=style&index=0&id=5588648c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5588648c"]])

export default __exports__